import * as React from 'react'

import * as Style from './style.css'

import {
  ColorButton,
  BUTTON_TYPE_PINK,
  BUTTON_TYPE_BLUE,
} from '~/atoms/button/ColorButton'

export const ContentWelcomeEntryForm = (): JSX.Element => {
  return (
    <div className={Style.ContentWelcomeEntryForm}>
      <div className={Style.ContentWelcomeEntryFormButtonSitter}>
        <ColorButton
          buttonType={BUTTON_TYPE_PINK}
          accordionTitle1="ベビーシッターの仕事に"
          accordionTitle2="申し込む"
          href="/sitters/welcome?source=award2024lp#welcomeform"
        />
      </div>
      <div className={Style.ContentWelcomeEntryFormButtonHousekeeping}>
        <ColorButton
          buttonType={BUTTON_TYPE_BLUE}
          accordionTitle1="家事代行サポーターの仕事に"
          accordionTitle2="申し込む"
          href="/housekeeping/welcome?source=award2024lp#welcomeform"
        />
      </div>
    </div>
  )
}
